import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import { QuoteProvider } from './context/QuoteContext';
import Layout from './components/Layout';
import Home from './pages/Home';
import Upload from './pages/Upload';
import Parameters from './pages/Parameters';
import Result from './pages/Result';

function App() {
  return (
    <ConfigProvider locale={zhCN}>
      <QuoteProvider>
        <BrowserRouter>
          <Layout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/upload" element={<Upload />} />
              <Route path="/parameters" element={<Parameters />} />
              <Route path="/result" element={<Result />} />
            </Routes>
          </Layout>
        </BrowserRouter>
      </QuoteProvider>
    </ConfigProvider>
  );
}

export default App;
